export default [
  {
    name: 'landing/overcome-corona',
    path: '/landing/overcome-corona',
    beforeEnter(to, from, next) {
      next()
    },
    component: require('@/views/landing/OvercomeCorona.vue').default
  },
  {
    name: 'landing/invitation/corona',
    path: '/landing/invitation/corona',
    beforeEnter(to, from, next) {
      next()
    },
    component: require('@/views/landing/invitation/InvitationCorona.vue').default
  },
  {
    name: 'landing/invitation/bnk',
    path: '/landing/invitation/bnk',
    component: require('@/views/landing/invitation/InvitationBnk.vue').default
  },
  {
    name: 'landing/manual',
    path: '/landing/manual',
    component: require('@/views/landing/Manual.vue').default
  }
]
